import {h, Fragment} from "preact"
import { useAppState, useSelectedFiltersCount } from '@nosto/preact'
import { defaultConfig, sortOptions } from '../config'
import Sidebar from './Sidebar'
import SortDropdown from './SortDropdown'

export default ({ sidebarOpen, toggleSidebar, gridView, toggleGridView }) => {
    const { response } = useAppState();
    const selectedFiltersCount = useSelectedFiltersCount();
    const docCount = response.products?.total ?? 0

    return (
        <div class='utility-bar'>
            
            <div class="utility-bar__left">
                <button
                    type="button"
                    class={`toggle-btn utility-bar__item ${sidebarOpen ? 'toggle-btn--revealed-desktop' : ''}`}
                    aria-label="Open filters"
                    onClick={toggleSidebar}
                >
                    <span class="btn-icon">
                        <svg role="presentation" aria-hidden="true" focusable="false" width="23" height="19" viewBox="0 0 20 20" stroke-width="1.25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <line x1="1" y1="6" x2="19" y2="6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></line><line x1="1" y1="14" x2="19" y2="14" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></line><circle cx="7" cy="6" r="3" fill="none" stroke="currentColor"></circle><circle cx="13" cy="14" r="3" fill="none" stroke="currentColor"></circle>
                        </svg>
                    </span>
                    <span>Filter</span>
                    {selectedFiltersCount > 0 && 
                        <span class="toggle-btn__count">({selectedFiltersCount})</span>
                    }
                    <span class="toggle-btn__chevron has-motion has-ltr-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" class="icon feather feather-chevron-right" aria-hidden="true" focusable="false" role="presentation">
                            <path d="m9 18 6-6-6-6"></path>
                        </svg>
                    </span>
                </button>
            </div>

            <div class="utility-bar__centre">
                <div class="utility-bar__item" data-nosto-element="totalResults">
                    {docCount} {docCount === 1 ? 'product' : 'products'}
                </div>
            </div>

            <div class="utility-bar__right">
                <div class="utility-bar__item desktop-only">
                    <SortDropdown />
                </div>

                <div class="utility-bar__item mobile-only">
                    <div class="layout-switchers">
                        <button 
                            class="layout-switch layout-switch--two-columns layout-switch--active" 
                            aria-label="Change product view to grid" 
                            type="button" 
                            disabled={gridView} 
                            onClick={toggleGridView}
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" class="icon feather feather-chevron-down" aria-hidden="true" focusable="false" role="presentation"><path d="M2 2h8v8H2V2M14 2h8v8h-8V2M14 14h8v8h-8v-8M2 14h8v8H2v-8"></path></svg>
                        </button>
                        <button 
                            class="layout-switch layout-switch--one-column" 
                            aria-label="Change product view to list" 
                            type="button" 
                            disabled={!gridView} 
                            onClick={toggleGridView}
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" class="icon feather feather-chevron-down" aria-hidden="true" focusable="false" role="presentation">
                                <path d="M2 2h20v20H2V2"></path>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
